<main class="loyale-auth-page loyale-auth-page--centered">
  <div class="auth-brand"><img src="../../../assets/logo.svg" alt="Loyale"></div>
  <section class="auth-card" aria-label="Preparing your invitation">
    <div class="auth-card__content auth-status">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="44"></mat-progress-spinner>
      <span>Preparing your invitation…</span>
    </div>
  </section>
</main>
